module.exports = __webpack_public_path__ + "static/media/16UNODC37.8cc91361.jpg";